import { Injectable } from '@angular/core';
import type { FormGroupDirective, NgForm, AbstractControl } from '@angular/forms';

/** Error state matcher that matches when a control is invalid and dirty. */
@Injectable()
export class ShowOnDirtyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control?.invalid && (control.dirty || form?.submitted));
  }
}

/** Provider that defines how form controls behave in regard to displaying error messages. */
@Injectable({ providedIn: 'root' })
export class ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control?.invalid && (control.touched || form?.submitted));
  }
}
